module.exports = __webpack_public_path__ + "media/images/athletes/14-0fa8575f726fc11ad014ab8a4240639e.png";